import React from "react";

class Offline extends React.Component {
  render() {
    return (
      <div className="cssload-loader">
        <div className="cssload-inner cssload-one" />
        <div className="cssload-inner cssload-two" />
        <div className="cssload-inner cssload-three" />
      </div>
    );
  }
}
export default Offline;
